<template>
  <div v-loading="loading">
    <el-form ref="form" label-width="100px">
      <el-form-item>
        <template slot="label">
          <span style="color: #a8abb2">货品SKU</span>
        </template>
        <span style="display: -webkit-box; -webkit-box-orient: vertical; line-clamp: 2; -webkit-line-clamp: 2; overflow: hidden; text-overflow: ellipsis; ">{{ pickingDetail.csku }}</span>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span style="color: #a8abb2">实际名称</span>
        </template>
        <span style="display: -webkit-box; -webkit-box-orient: vertical; line-clamp: 2; -webkit-line-clamp: 2; overflow: hidden; text-overflow: ellipsis; ">{{ pickingDetail.sgoods }}</span>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span style="color: #a8abb2">实际库存</span>
        </template>
        <span style="display: -webkit-box; -webkit-box-orient: vertical; line-clamp: 2; -webkit-line-clamp: 2; overflow: hidden; text-overflow: ellipsis; ">{{ inventory.nall }}</span>
      </el-form-item>
      <el-form-item label="*实际库存">
        <el-input style="width: 210px;" placeholder="请输入" v-model="surplus" />
      </el-form-item>
      <el-form-item label="*校正备注">
        <el-input style="width: 210px;" placeholder="请输入备注" v-model="remake" />
      </el-form-item>
    </el-form>
    <div>
      <el-button type="primary" @click="onSubmit">提 交</el-button>
      <el-button @click="onCancel">关 闭</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderGoodsAdd",
  components: {
    // NoData,
  },
  props: {
    pickingDetail: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      remake: '',
      surplus: '',
      inventory: {},
      loading: false,
    };
  },
  mounted() {
    if (this.pickingDetail.rinventory === undefined) {
      this.topsAjax.get(`${this.baseUrls.ordPicking}/queryInventoryById`, { inventoryId: this.pickingDetail.sid }).then(res => {
        this.inventory = res;
        this.inventory.sheetPickId = this.pickingDetail.rpicking;
      });
    } else {
      this.topsAjax.get(`${this.baseUrls.ordPicking}/queryInventoryById`, { inventoryId: this.pickingDetail.rinventory }).then(res => {
        this.inventory = res;
        this.inventory.sheetPickId = this.pickingDetail.rpicking;
      });
    }
  },
  methods: {
    onSubmit() {
      if (this.remake === undefined || this.remake === '') {
        this.$message({
          message: "请填写备注（缺货/损坏/数量多了等）",
          type: "error",
        });
        return
      }
      this.loading = true;
      let url = `${this.baseUrls.viewInventory}/sheet/add`;
      this.topsAjax.post(url, { ...this.inventory, sheetRemark: this.remake, checkSurplus: this.surplus }).then(() => {
        this.$message({
          message: "校正成功",
          type: "success",
        });
        this.loading = false;
        this.$emit("handleSubmit", this.surplus);
      });
    },
    onCancel() {
      this.$emit("handleClose");
    }
  },
};
</script>

<style lang="scss">
.newOrderGoodsAdd {
  height: 600px;
  background-color: white;
  display: flex;
  flex-direction: column;



  .el-tabs__item {
    padding: 0 10px;
  }

  .el-tabs__item.is-active {
    text-decoration: underline;
  }


  .el-popper[x-placement^="bottom"] {
    margin-left: -40px;
  }
}

//.orderGoodsAdd {
//  height: 500px;
//  background-color: white;
//  display: flex;
//  flex-direction: column;
//
//  &__top {
//    flex: 1;
//  }
//
//  &__bottom {
//    height: 50px;
//    line-height: 50px;
//    text-align: right;
//  }
//
//  .el-input {
//    width: 120px;
//  }
//
//  .cell {
//    & > div {
//      width: 120px;
//    }
//  }
//}
</style>
